'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DeliveryDispatchInfo = exports.Section = exports.OrdersInfo = exports.Menu = exports.ReservationsInfo = exports.Platform = exports.Order = exports.Contact = exports.Payment = exports.Dispatch = exports.Restaurant = exports.Reservation = exports.OrderItem = exports.OrderCharge = exports.ChargeV2 = exports.Availability = undefined;

var _Restaurant = require('./Restaurant.js');

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _Availability = require('./Availability.js');

var _Availability2 = _interopRequireDefault(_Availability);

var _ChargeV = require('./ChargeV2.js');

var _ChargeV2 = _interopRequireDefault(_ChargeV);

var _OrderCharge = require('./OrderCharge.js');

var _OrderCharge2 = _interopRequireDefault(_OrderCharge);

var _OrderItem = require('./OrderItem.js');

var _OrderItem2 = _interopRequireDefault(_OrderItem);

var _Reservation = require('./Reservation.js');

var _Reservation2 = _interopRequireDefault(_Reservation);

var _Dispatch = require('./Dispatch.js');

var _Dispatch2 = _interopRequireDefault(_Dispatch);

var _Payment = require('./Payment.js');

var _Payment2 = _interopRequireDefault(_Payment);

var _Contact = require('./Contact.js');

var _Contact2 = _interopRequireDefault(_Contact);

var _Order = require('./Order.js');

var _Order2 = _interopRequireDefault(_Order);

var _Platform = require('./Platform.js');

var _Platform2 = _interopRequireDefault(_Platform);

var _ReservationsInfo = require('./ReservationsInfo.js');

var _ReservationsInfo2 = _interopRequireDefault(_ReservationsInfo);

var _Menu = require('./Menu.js');

var _Menu2 = _interopRequireDefault(_Menu);

var _OrdersInfo = require('./OrdersInfo.js');

var _OrdersInfo2 = _interopRequireDefault(_OrdersInfo);

var _Section = require('./Section.js');

var _Section2 = _interopRequireDefault(_Section);

var _DeliveryDispatchInfo = require('./DeliveryDispatchInfo.js');

var _DeliveryDispatchInfo2 = _interopRequireDefault(_DeliveryDispatchInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Availability = _Availability2.default;
exports.ChargeV2 = _ChargeV2.default;
exports.OrderCharge = _OrderCharge2.default;
exports.OrderItem = _OrderItem2.default;
exports.Reservation = _Reservation2.default;
exports.Restaurant = _Restaurant2.default;
exports.Dispatch = _Dispatch2.default;
exports.Payment = _Payment2.default;
exports.Contact = _Contact2.default;
exports.Order = _Order2.default;
exports.Platform = _Platform2.default;
exports.ReservationsInfo = _ReservationsInfo2.default;
exports.Menu = _Menu2.default;
exports.OrdersInfo = _OrdersInfo2.default;
exports.Section = _Section2.default;
exports.DeliveryDispatchInfo = _DeliveryDispatchInfo2.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/fixtures/index.js
// module id = 900
// module chunks = 0